import React from "react";
import { NavLink } from "react-router-dom";

export const CustomLink = ({ path, color, text, onClick }) => (
  <NavLink onClick={onClick} style={{ color }} to={path}>
    {text}
  </NavLink>
);
